import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router'
import { Form, 
				 Row, 
				 Container, 
				 Col, 
				 Button, 
				 Spinner, 
				 Alert } from 'react-bootstrap';
import { apiGetCurrentUser, apiCreateEvent, apiBookmarkEvent } from '../api/api'

import './EventCreate.css'

const EventCreate = () => {
	let navigate = useNavigate()
	const [isPosting, setIsposting] = useState(false)
	const [isCreateFailed, setIsCreateFailed] = useState(false)
	const [adminEmail, setadminEmail] = useState('')
	const [inputTitle, setInputTitle] = useState('')
	const [inputLocation, setInputLocation] = useState('')
	const [inputLink, setInputLink] = useState('')
	const [inputDate, setInputDate] = useState('')
	const [inputTime, setInputTime] = useState('')
	const [inputPrice, setInputPrice] = useState('')
	const [inputContactPerson, setInputContactPerson] = useState('')
	const [inputDescription, setInputDescription] = useState('')
	const [inputFile, setInputFile] = useState('')

	const init = async () => {
		apiGetCurrentUser().then(res => {
			console.log(res)
			setadminEmail(res.data.user.email)
		}).catch(error => {
			navigate('/')
			console.log(error.response)
		})
	}

	const createFailed = () => {
		setIsCreateFailed(true)
		setIsposting(false)
	}

	const handleFileChange = (event) => {
		setInputFile(event.target.files[0])
	}

	const handleSubmit = async (event) => {
		setIsposting(true)
		event.preventDefault()
		const data = {
			"name": inputTitle,
			"status": "open",
			"description": inputDescription,
			"dateTime": inputDate + " " + inputTime,
			"location": inputLocation,
			"contact": inputContactPerson,
			"link": inputLink,
			"price": inputPrice,
			"organizer": adminEmail
		}
		const formData = new FormData();
		formData.append('form_data', JSON.stringify(data));
		inputFile && formData.append('file', inputFile);
		console.log(formData)
		apiCreateEvent(formData).then(async (res) => {
			await apiBookmarkEvent(res.data.inserted_id)
			navigate(`/event/${res.data.inserted_id}`)
			console.log(res.data)
		}).catch(error => {
			console.log(error.response)
			createFailed()
			if (error.response !== undefined) {
					alert("Something went wrong, check console! ===>" + 
									error.response.data.detail)
			} else {
					alert("Something went wrong")
			}
		})
	}

	const handleCancel = (event) => {
		navigate(`/explore`)
	}

	useEffect(() => {
		init()
	}, [])

	//handle form changes
	const handleTitleChange = (event) => {
		setInputTitle(event.target.value)
	}

	const handleLocationChange = (event) => {
		setInputLocation(event.target.value)
	}

	const handleLinkChange = (event) => {
		setInputLink(event.target.value)
	}

	const handleDateChange = (event) => {
		setInputDate(event.target.value)
	}

	const handleTimeChange = (event) => {
		setInputTime(event.target.value)
	}

	const handlePriceChange = (event) => {
		setInputPrice(event.target.value)
	}

	const handleContactPersonChange = (event) => {
		setInputContactPerson(event.target.value)
	}

	const handleDescriptionChange = (event) => {
		setInputDescription(event.target.value)
	}

	return (
		<Container>
			<div id="create-event-head">
				<h3 id="create-event-header">Create Event</h3>
				<hr></hr>
			</div>
			{isCreateFailed ? 
				<div>
					<Alert variant="danger" 
								 onClose={() => setIsCreateFailed(false)} dismissible>
							<Alert.Heading>Oh snap! You got an error!</Alert.Heading>
							<p>
									An error has occured
							</p>
					</Alert>
				</div> : 
				<div>
				</div>
			}
			<Form onSubmit={handleSubmit}>
				<Row>
					<Col>
						<Row>
							<Form.Group>
								<Form.Label>Title</Form.Label>
								<Form.Control data-testid="input-event-title" 
															value={inputTitle} 
															type="text" 
															name="title" 
															onChange={handleTitleChange} 
															maxLength="50" 
															required>
								</Form.Control>
							</Form.Group>
							<Form.Group>
								<Form.Label>Location</Form.Label>
								<Form.Control data-testid="input-event-location" 
															value={inputLocation} 
															type="text" 
															name="location" 
															onChange={handleLocationChange} 
															maxLength="30" 
															required>
								</Form.Control>
							</Form.Group>
							<Form.Group>
								<Form.Label>Link/url</Form.Label>
								<Form.Control data-testid="input-event-link" 
															value={inputLink} 
															type="url" 
															name="link" 
															onChange={handleLinkChange} 
															maxLength="100" 
															required>
								</Form.Control>
							</Form.Group>
							<Form.Group>
								<Form.Label>Date</Form.Label>
								<Form.Control data-testid="input-event-date" 
															value={inputDate} 
															type="date" 
															name="date" 
															onChange={handleDateChange} 
															required>
								</Form.Control>
							</Form.Group>
							<Form.Group>
								<Form.Label>Time</Form.Label>
								<Form.Control data-testid="input-event-time" 
															value={inputTime} 
															type="time" 
															name="time" 
															onChange={handleTimeChange} 
															required>
								</Form.Control>
							</Form.Group>
						</Row>
					</Col>
						<Col>
							<Form.Group>
								<Form.Label>Description</Form.Label>
								<Form.Control data-testid="input-event-description"
															value={inputDescription} 
															type="text" 
															as="textarea" 
															name="description" 
															onChange={handleDescriptionChange} 
															maxLength="255" 
															required>
								</Form.Control>
							</Form.Group>
							<Form.Group>
								<Form.Label>Price</Form.Label>
								<div className="input-with-prefix-box">
									<span className="prefix">IDR</span>
									<Form.Control data-testid="input-event-price"
										value={inputPrice}
										type="number"
										name="price"
										onChange={handlePriceChange}
										className="input-with-prefix"
										maxLength="12">
									</Form.Control>
								</div>
							</Form.Group>
							<Form.Group>
							<Form.Label>Contact</Form.Label>
								<div className="input-with-prefix-box">
									<span className="prefix">+62</span>
									<Form.Control data-testid="input-event-contact-person" 
																value={inputContactPerson} 
																type="number" 
																name="contactPerson" 
																onChange={handleContactPersonChange} 
																maxLength="12" 
																className="input-with-prefix" 
																required>
									</Form.Control>
								</div>
							</Form.Group>
							<Form.Group>
								<Form.Label>Image</Form.Label>
								<Form.Control data-testid="input-event-file"
															type="file" 
															onChange={handleFileChange} />
							</Form.Group>
						</Col>
				</Row>
				<Row style={{ marginTop: '10vh' }}>
					<Col style={{ display: 'flex', justifyContent: 'right' }}>
						{isPosting ?
							<Row>
								<Col style={{ display: 'flex', justifyContent: 'right' }}>
									<Button variant="dark" 
													style={{ display: 'flex', 
																	 justifyContent: 'right' }} 
													onClick={handleCancel} 
													id="cancel-button" 
													disabled> 
													Cancel
									</Button>
									<Button variant="warning" 
													type="submit" 
													id="submit-button" 
													disabled>
													<Spinner as="span" 
																	 animation="border" 
																	 size="sm" 
																	 role="status" 
																	 aria-hidden="true"/>
									</Button>
								</Col> 
							</Row> :
							<Row>
								<Col style={{ display: 'flex', justifyContent: 'right' }}>
									<Button variant="dark" 
													style={{ display: 'flex', 
																	 justifyContent: 'right' }} 
													onClick={handleCancel} 
													id="cancel-button"> 
													Cancel
									</Button>
									<Button variant="warning" 
													type="submit" 
													id="submit-button">
													Submit
									</Button>
								</Col>
							</Row>
						}
					</Col>
				</Row>
			</Form>
		</Container>
	)
}

export default EventCreate;